export default __webpack_public_path__ + "static/zoe-35097f344ba4b575f66ca5cf9b00fc88.png";